<div class="row">
  <div class="col-lg-12">
    <div class="flex flex-col gap-3 justify-center text-center px-4 mb-5 text-muted">
      <a href="/" class="flex justify-center items-center">
        <img src="images/logomedinbox.svg" alt="Logo Medinbox" class="w-75" />
      </a>
      <p>All-in-one checklist for connectivity, media access and quality</p>
    </div>
  </div>
</div>
